<motn-drawer-height-from-bottom
  [addToBottomHeight]="100"
  (clickedOutside$)="clickedOutside$.emit($event)"
>
  <h3>
    Configure Point

    <motn-pill>Modbus TCP</motn-pill>
  </h3>

  <div
    class="editor"
  >
    <div
      class="group"
    >
      <div>
        <input
          [(ngModel)]="name"
        >
        <div
          class="label"
        >
          Name
        </div>
      </div>

      <div>
        <input
          [(ngModel)]="config.Address"
          type="number"
        >
        <div
          class="label"
        >
          Address
        </div>
      </div>
    </div>

    <div
      class="group"
    >
      <div>
        <div
          class="fake-select"
          [innerText]="displayDataType"
          (click)="dataTypeOptions.menuActive = true"
        ></div>

        @if (dataTypeOptions?.menuActive) {
          <motn-popover-multi-select
            [multiOrSingle]="'single'"
            [optionGroup]="dataTypeOptions"
            [inputPlaceholder]="'Search data types...'"
            [overlayPositions]="overlayPositions"
            (clickedOutsideMenu$)="dataTypeOptions.menuActive = false"
            (clickedOption$)="updateAllSelections(); dataTypeOptions.menuActive = false"
          ></motn-popover-multi-select>
        }

        <div
          class="label"
        >
          Data Type
        </div>
      </div>

      <div>
        <div
          class="fake-select"
          [innerText]="displayFunctions"
          (click)="functionsOptions.menuActive = true"
        ></div>

        @if (functionsOptions?.menuActive) {
          <motn-popover-menu
            [optionGroup]="functionsOptions"
            [overlayPositions]="overlayPositions"
            (clickedAnywhere$)="functionsOptions.menuActive = false"
            (clickedOption$)="updateAllSelections()"
          ></motn-popover-menu>
        }

        <div
          class="label"
        >
          Functions
        </div>
      </div>

      <div>
        <div
          class="fake-select"
          [innerText]="displayByteOrder"
          (click)="byteOrderOptions.menuActive = true"
        ></div>

        @if (byteOrderOptions?.menuActive) {
          <motn-popover-menu
            [optionGroup]="byteOrderOptions"
            [overlayPositions]="overlayPositions"
            (clickedAnywhere$)="byteOrderOptions.menuActive = false"
            (clickedOption$)="afterByteOrderChange()"
          ></motn-popover-menu>
        }

        <div
          class="label"
        >
          Byte Order
        </div>
      </div>
    </div>

    <div class="button-group">
      <button
        (click)="testRead$.emit(config)"
        [ngClass]="{'small': 1, 'blue': 1, 'loading': testingRead}"
      >
        <span>Test Read</span>
        <motn-spinner></motn-spinner>
      </button>

      @if (config.Writable) {
        @if (is1BitType()) {
          <button
            (click)="testWriteFalse$.emit(config)"
            class="small blue"
          >
            <span>Test Write FALSE</span>
          </button>
          <button
            (click)="testWriteTrue$.emit(config)"
            class="small blue"
          >
            <span>Test Write TRUE</span>
          </button>
        } @else {
          <button
            (click)="testWrite$.emit(config)"
            class="small blue"
          >
            <span>Test Write</span>
          </button>
        }
      }

      <button
        (click)="save()"
        [ngClass]="{'small': 1, 'loading': saving}"
      >
        <span>Save</span>
        <motn-spinner></motn-spinner>
      </button>
    </div>
  </div>
</motn-drawer-height-from-bottom>
